// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__BVoSo","imageUploader":"EGiftCard_imageUploader__3Td_c"};